module.exports = __webpack_public_path__ + "static/img/headerBar.211a3028.png";